function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeTextFieldStyles = function makeTextFieldStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& [class*='MuiInputBase-root'][class*='MuiOutlinedInput-root']": _objectSpread(_objectSpread({
            border: "1px solid transparent",
            borderRadius: 0,
            paddingRight: primitives.spacings["0"]
          }, tokens.transitions["state-activate"]), {}, {
            "&.Mui-focused": {
              border: "1px solid ".concat(tokens.colors["ink-hover"]),
              boxShadow: "0px -1px 0px 0px ".concat(tokens.colors["ink-on-background"], " inset, 0px 0px 0px 1px ").concat(tokens.colors["ink-hover"], " inset")
            },
            "&:hover": {
              borderBottom: "1px solid ".concat(tokens.colors["ink-hover"])
            },
            "&:focus-within": {
              border: "1px solid ".concat(tokens.colors["ink-hover"]),
              boxShadow: "0px -1px 0px 0px ".concat(tokens.colors["ink-on-background"], " inset, 0px 0px 0px 1px ").concat(tokens.colors["ink-hover"], " inset")
            },
            "&.Mui-error": {
              boxShadow: tokens.effects["field-error"],
              border: "1px solid ".concat(primitives.colors.detail.transparent),
              "&:hover": {
                borderBottomColor: primitives.colors.detail.transparent,
                "&.Mui-focused": {
                  boxShadow: tokens.effects["field-error"],
                  border: "1px solid ".concat(primitives.colors.detail.transparent)
                }
              }
            },
            "&.Mui-disabled": {
              borderBottomColor: primitives.colors.detail.transparent
            },
            "& [class*='MuiOutlinedInput-input']": _objectSpread(_objectSpread({
              padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["0"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"])
            }, tokens.typography["input-value"]), {}, {
              "&::placeholder": _objectSpread({}, tokens.typography["short-copy-medium"]),
              "&.Mui-disabled": {
                WebkitTextFillColor: tokens.colors["ink-on-background"]
              },
              "&::selection": {
                background: tokens.colors["activated-hover-fill-subtle"]
              },
              "&::-moz-selection": {
                background: tokens.colors["activated-hover-fill-subtle"]
              }
            }),
            '& [class*="MuiInputAdornment-positionEnd"]': {
              marginLeft: primitives.spacings["1"],
              marginRight: primitives.spacings["1"],
              "& [class*='MuiButtonBase-root'][class*='MuiIconButton-root']": {
                "&:active": {
                  backgroundColor: tokens.colors["pressed-fill-subtle"]
                },
                "&.Mui-focusVisible": {
                  boxShadow: tokens.effects["focus-ring-thin"]
                },
                height: primitives.spacings["7"],
                marginRight: primitives.spacings["0"],
                padding: primitives.spacings["0"],
                width: primitives.spacings["7"],
                "& svg": {
                  color: tokens.colors["fill-primary"],
                  height: primitives.spacings["5"],
                  width: primitives.spacings["5"]
                }
              }
            }
          })
        }
      }
    }
  };
};